import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import { useCashOutReward, useGetTotalRewards, useGetNodeNumber } from '../../hooks/token';
import { getNumber } from '../../utils/utils';
import { useTheme } from '../../hooks';
import { updateActiveLinkState } from '../../redux/actions/uiActions';

let __totalRewards = [0, 0, 0, 0];

const Reward = ({ tier, onUpdateRewardsOfNode }) => {
  const totalRewards = useGetTotalRewards(tier);
  const [prevTotalRewards, setPrevTotalRewrads] = useState(-1);

  if (totalRewards?.data && !totalRewards.isLoading) {
    if (totalRewards.data !== prevTotalRewards) {
      setPrevTotalRewrads(totalRewards.data);
      onUpdateRewardsOfNode(totalRewards);
    }
  }
  // console.log('tier', tier)
  return <>{totalRewards?.data && !totalRewards.isLoading ? Number(getNumber(totalRewards.data, 6)).toFixed(3) : 0}</>;
};

const RewardClaim = ({ tier, classes }) => {
  const { cashOutReward, isLoading } = useCashOutReward(tier);
  return (
    <div className={`${styles.hideBtn} ${classes.hideBtn}`} onClick={() => cashOutReward([undefined])}>
      Claim
    </div>
  );
};

const CountPerTier = ({ tier, onNodesChange }) => {
  const numberOfNodes = useGetNodeNumber(tier);

  const condition = useMemo(() => {
    if (numberOfNodes.data > 0) {
      return true;
    }
    return false;
  }, [numberOfNodes]);

  useEffect(() => {
    if (condition) {
      onNodesChange(1);
    }
  }, [condition]);
  return <>{numberOfNodes?.data ? numberOfNodes?.data : 0}</>;
};

const Boxes = ({ hideHover, onChangeTotalRewards }) => {
  const { nodesData } = useSelector((state) => state.ui);
  const [activeImg, setActiveImg] = useState(false);
  const [totalRewards, setTotalRewards] = useState([0, 0, 0, 0]);
  const [godMode, setGodMode] = useState(0);
  let isGodMode = false;
  const { theme, toggleThemeF } = useTheme();
  // console.log('godMode', godMode);
  // console.log('nodeLength', nodesData.length);
  if (godMode === nodesData.length) {
    isGodMode = true;
  }
  if (theme === 'dark' && isGodMode) {
    toggleThemeF();
  } else if (theme === 'light' && !isGodMode) {
    toggleThemeF();
  }
  const useStyles = makeStyles((theme) => ({
    hideBtn: {
      background: theme.palette.background.hoverBgPay,
      color: theme.palette.text.primary,
    },
  }));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navClickHandler = (idx, _name) => {
    navigate('nodes/' + _name);
    setTimeout(() => {
      dispatch(updateActiveLinkState(1, true));
    }, 1000);
    dispatch(updateActiveLinkState(idx, false));
  };
  useEffect(() => {
    try {
      onChangeTotalRewards(totalRewards.reduce((sum, item) => (sum = sum + item)));
    } catch (e) {}
  }, [totalRewards]);

  const onUpdateTotalRewards = (index, rewardsOfNode) => {
    __totalRewards[index] = Number(getNumber(rewardsOfNode.data, 6));
    onChangeTotalRewards(__totalRewards.reduce((sum, item) => (sum = sum + item)));
    //setTotalRewards(__totalRewards);
  };

  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      {/* {Array.from(Array(4)).map((_, index) => ( */}
      {nodesData.map((_, index) => (
        <Grid item xs={3} key={index}>
          <div
            className={styles.mainContainer}
            onMouseOver={() => setActiveImg((prev) => (prev === index ? null : index))}
            onMouseOut={() => setActiveImg(null)}
          >
            <div
              className={styles.spidercard}
              onClick={() => (hideHover ? navClickHandler(1, _.name) : '')}
            >
              <img
                // src={index === 0 ? imgNode2 : index === 1 ? imgNode3 : index === 2 ? imgNode1 : imgNode4}
                src={activeImg === index ? _.hoverImg : _.img}
                alt="cards"
                width={'auto'}
                height={'50px'}
              />
              {hideHover ? (
                <div className={styles.spidernumber}>
                  <CountPerTier
                    tier={_.name.toUpperCase()}
                    onNodesChange={(nodes) => {
                      setGodMode((prev) => nodes + prev);
                    }}
                  />
                </div>
              ) : (
                <div className={styles.spidernumber}>
                  <Reward tier={_.name.toUpperCase()} onUpdateRewardsOfNode={(e) => onUpdateTotalRewards(index, e)} />
                </div>
              )}
            </div>
            {!hideHover ? <RewardClaim classes={classes} tier={_.name.toUpperCase()} /> : null}
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default Boxes;
